module.exports = __webpack_public_path__ + "img/empty-img@4x.4974a6ff.png";